import { makeAutoObservable, runInAction, configure } from 'mobx';
import { DeliveryRequest } from '../models/deliveryRequest';
import {
  FileUploadInterface,
  LocalUploadInterface,
  UserData,
} from '../models/Profile';
import { WorkLevel } from '../models/workLevel';
import { store } from './store';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { Template } from '../models/template';
import { initialPostFilteredItemDetails } from '../models/metaDataConfig';

configure({
  enforceActions: 'never',
});

interface CameraDataRegister {
  fileId: string;
  id: string;
  fileName: string;
  url: string;
}

interface Dashboard {
  selectedUserRoleId: string[];
  signUpUserModal: boolean;
  open: boolean;
  cardss: boolean;
  L1CardValue: string;
  gradientvalue: number;
  openstatus: boolean;
  DenialModal: boolean;
  ApproveDenialHeader: string;
  ActivityForModal: any;
  reportsConfiguration: boolean;
  valueForL3Inventory: string;
  valueForL3Orders: string;
  valueForL4Orders: string;
  // For Left Side Table CLicked value
  assetTableClickedValueTag: string;
  AssetTableAssignClicked: string;
  AssetTableCreateOrderClicked: string;
  AssetTableDeliveryClicked: string;
  OutwardTableBillingClicked: string;
  billingPagination: number;
  assetTableCRClicked: string;
  // L2 Card Values
  L2CardValuePlanning: string;
  L2CardValueInventory: string;
  L2CardValueOrders: string;
  valueForL3Planning: string;
  // fade in- fade out condition for inventory
  setfadeIn: boolean;
  onFirstLoadNoTransition: boolean;
  //for orders Regster
  orderRequestDetailsIds: string;
  //
  // for dashboard Verify
  dataForChildTab: string[];
  checkClikedWorkLevel: {
    id: string;
    title: string;
    barcode_Package: string;
    senderDetails:string
  };
  dashboardWorkLevelMaster: WorkLevel;
  // creates panes at tab pane in workflow tab tag,tabcategory
  // open camera model
  openCameraModal: boolean;
  // open WorklevelMasterModal
  openWorkLevelMasterModal: boolean;
  // cam image
  camImageBase64: Blob[];
  // url string
  camImageUrl: CameraDataRegister[];
  // fileuploadimage url
  verifyImageUrl: FileUploadInterface[];
  // open modal for qrcode scanner
  openQrCodeScanner: boolean;
  getQrCodeValue: string;
  // open modal for qrcode scanner
  openBarCodeScanner: boolean;
  getBarCodeValue: string;
  // open modal for openRfidScanner scanner
  openRfidScanner: boolean;
  getRfidValue: string;
  //create order client
  createOrderClientId: string;
  createOrderDepartmentId: string;
  //
  deliveryOrderTableClicked: boolean;
  tableconfigurationClicked: any[];
  tabledataValue: any[];
  finalvalue: any[];
  headerTable: any[];
  drag: any[];
  tableName: string;
  isDipatchCalled: boolean;
  loadingCount: boolean;
  openDash: boolean;
  //for approve or deny modal
  denyProcess: boolean;
  /////////create Order Call back use effect
  createOrderSaveClicked: boolean;
  formikClearFormBool: boolean;
  //selected Template for CR
  CreateOrderTemplate: Template | undefined;
  CreateOrderTemplate1: Template | undefined;
  //dynamic table component row data id
  rowIdForDynamicTable: any;
  loadingdata: string;
  //inventory count
  completedOrderCount: number;
  totalOrderCount: number;
  prodCount: number;
  taskCount: number;
  taskTotal: number;
  inventoryCount: number;
  inventoryCount2: number;
  movementCount: number;
  unSyncedData: any[]
  syncedData: any[]
  unsyncedCount:number;
  syncedCount:number;
  ScanCount: number;
  HFCReturnCount:number;
  HFCReceivingCount: number;
  AssignCount:number;
  HFCServiceCount:number;
  shipperCount:number;
  VaultCount:number;
  shippingPrepCount:number;
  shippingCount:number;
  itemgroupsCount: number;
  pullCount:number;
  messageCount: number;
  receivingsCount: number;
  FFNotTableCount: number;
  FFTableCount: number;
  tagCount: number;
  CreateOrderCount: number;
  //search filter
  searchfilterparams: any;
  dateSearchCleared: any;
  focusState: string;

  //sort
  orderData: string;
  
  //sort order Icon
  orderName: string;
  orderIcon: any;
  prodPlanTableLength: number;
  getL3Task: number;
  inventoryChartData: any;
  orderChartData: any;
  prodChartData: any;
  prodChartLabel: any;
  ProdChartComplete: any;
  ProdchartInprogress: any;
  ProdchartInprogressLabel: any;
  ProdChartUpdateLabel: any;
  isFilmFestival: boolean;
  setCRTablePageNumber: number;
  setTagTablePageNumber: number;
  setRegisterPageNumber: number;
  setReportsPageNum: number;
  setProdPageNumber: number;
  setProductionTask: string;
  setProductionType: string;
  productionSearchCount: number;

  inventoryDoughnutChartDetails: {
    type: string;
    count: number;
  }[];
  updateLocalFileAPI: LocalUploadInterface[];
  localFilesForItem: {
    files: { id: string; fileName: string; path: string; createdAt: string }[];
    folderName: string;
  }[];
  // localFileIP: string;
}
const initialState = {
  selectedUserRoleId: [],
  signUpUserModal: false,
  open: true,
  cardss: false,
  L1CardValue: '',
  loadingCount: false,
  gradientvalue: 0,
  // check later
  openstatus: false,

  DenialModal: false,
  ApproveDenialHeader: '',
  ActivityForModal: [],
  unSyncedData:[],
  syncedData:[],
  reportsConfiguration: false,

  valueForL3Planning: '',
  L2CardValuePlanning: '',
  L2CardValueInventory: '',
  valueForL3Inventory: '',
  valueForL3Orders: '',
  valueForL4Orders:'',
  L2CardValueOrders: '',
  //for orders Regster
  orderRequestDetailsIds: '',

  assetTableClickedValueTag: '',

  AssetTableAssignClicked: '',
  AssetTableCreateOrderClicked: '',
  AssetTableDeliveryClicked: '',
  OutwardTableBillingClicked: '',
  billingPagination: 0,
  assetTableCRClicked: '',
  // fade in and out
  setfadeIn: false,
  onFirstLoadNoTransition: true,
  //  for Dashboard verify
  dataForChildTab: [''],
  checkClikedWorkLevel: {
    id: '',
    title: '',
    barcode_Package: '',
    senderDetails:''
  },
  dashboardWorkLevelMaster: {
    id: '',
    title: '',
    year: '',
    language: '',
    originIndia: '',
    isActive: true,
    isDeleted: false,
    isMaster: false,
  },
  //  for Dashboard verify
  //for approve or deny modal
  denyProcess: false,
  // open camera model
  openCameraModal: false,
  // open WorklevelMasterModal
  openWorkLevelMasterModal: false,
  //  cam image
  camImageBase64: [],
  // url string
  camImageUrl: [],
  // fileuploadimage url
  verifyImageUrl: [],

  // open modal for qrcode scanner
  openQrCodeScanner: false,
  getQrCodeValue: '',

  // open modal for qrcode scanner
  openBarCodeScanner: false,
  getBarCodeValue: '',
  // open modal for openRfidScanner scanner
  openRfidScanner: false,
  getRfidValue: '',
  //create order client
  createOrderClientId: '',
  createOrderDepartmentId: '',
  // delivery order register
  deliveryOrderTableClicked: false,
  tableconfigurationClicked: [],
  tabledataValue: [],
  finalvalue: [],
  headerTable: [],
  drag: [],
  tableName: '',
  //dispatch action on Dynamic Table
  isDipatchCalled: false,
  openDash: true,
  /////////create Order Call back use effect
  createOrderSaveClicked: false,
  formikClearFormBool: false,
  //selected Template for CR
  CreateOrderTemplate: undefined,
  CreateOrderTemplate1: undefined,
  //dynamic table component row data id
  rowIdForDynamicTable: -1,
  loadingdata: 'loading',
  //inventory count
  totalOrderCount: 0,
  prodCount: 0,
  taskCount: 0,
  completedOrderCount: 0,
  taskTotal: 0,
  inventoryCount: 0,
  inventoryCount2: 0,
  movementCount:0,
  ScanCount:0,
  unsyncedCount:0,
  syncedCount:0,
  HFCReturnCount:0,
  HFCReceivingCount:0,
  HFCServiceCount:0,
  AssignCount:0,
  shipperCount:0,
  pullCount:0,
  shippingPrepCount:0,
  shippingCount:0,
  VaultCount:0,
  itemgroupsCount: 2,
  messageCount: 49,
  receivingsCount: 0,
  FFNotTableCount: 0,
  FFTableCount: 0,
  tagCount: 0,
  CreateOrderCount: 0,
  //search filter
  searchfilterparams: {},
  dateSearchCleared: [],
  focusState: '',
  //sort
  orderData: '',
  //sort order Icon
  orderIcon: '',
  orderName: '',
  prodPlanTableLength: 0,
  getL3Task: 0,
  inventoryChartData: {},
  orderChartData: {},
  prodChartData: [
    { Label: [''] },
    { Chart1: [] },
    { Chart2: [] },
    { Chart3InProgress: [] },
    { Chart3Complete: [] },
  ],
  isFilmFestival: false,
  prodChartLabel: [],
  ProdchartInprogress: [],
  ProdChartComplete: [],
  ProdChartUpdateLabel: [],
  setCRTablePageNumber: 1,
  setTagTablePageNumber: 1,
  setRegisterPageNumber: 1,
  setReportsPageNum: 1,
  setProdPageNumber: 1,
  setProductionTask: '',
  setProductionType: '',
  productionSearchCount: 0,
  inventoryDoughnutChartDetails: [],
  updateLocalFileAPI: [],
  localFilesForItem: [],
  ProdchartInprogressLabel: [],
  // localFileIP: "http://172.16.0.138:8887/"
};
export default class dashboardStore {
  static dashboard: any;
  constructor() {
    makeAutoObservable(this);
  }

  getMenuCount: UserData = {
    userId: '',
    isAdmin: false,
    isGroupAdmin: false,
    customerName: '',
    inventoryCount: 0,
    totalOrderCount: 0,
    completedOrderCount: 0,
    productionCount: 0,
    totalTaskCount: 0,
    completedTaskCount: 0,
    itemgroups: 0,
    receivings: 0,
    message: 0,
  };
  // isGetMenuCount:boolean = false;
  dashboard: Dashboard = initialState;

  clear_SortSearch_Input = () => {
    this.dashboard.searchfilterparams = {};
    this.dashboard.orderData = '';
    //sort order Icon
    this.dashboard.orderIcon = '';
    this.dashboard.orderName = '';
  };

  setSelectedUserRoleIds = (e: string[]) => {
    this.dashboard.selectedUserRoleId = e;
  };

  openSignUpUserModal = (e: boolean) => {
    this.dashboard.signUpUserModal = e;
  };
  // this one is for opening stepper below inventory ,planning,orders
  openL2Cards = (e: string, d: number) => {
    this.dashboard.cardss = true;
    this.dashboard.L1CardValue = e;
    this.dashboard.gradientvalue = d;

    if (this.dashboard.L1CardValue !== 'Production')
      this.dashboard.L2CardValuePlanning = '';
    this.dashboard.L2CardValueInventory = '';
    this.dashboard.L2CardValueOrders = '';
    this.dashboard.valueForL3Orders = '';
    this.dashboard.valueForL3Planning = '';
    this.dashboard.openstatus = true;

    //setting the data to empty
    this.setcamImageBase64([]);
    this.setRegisterUrlResponse([]);
    store.receivingdeliveryStore.selectedReceivingDelivery = undefined;
    this.clear_SortSearch_Input();
  };
  // for all cards on clicked
  closecard = () => {
    this.dashboard.cardss = !this.dashboard.cardss;
    this.dashboard.L2CardValuePlanning = '';
    this.dashboard.L2CardValueInventory = '';
    this.dashboard.L1CardValue = '';
  };
  // this one is production
  openL2ForPlanning = (e: string) => {
    this.dashboard.L2CardValuePlanning = e;
    this.dashboard.valueForL3Planning = '';
    this.dashboard.valueForL3Inventory = '';
    this.dashboard.L2CardValueInventory = '';
    this.clear_SortSearch_Input();
  };
  // this one is for inventory
  openL2ForInventory = (e: string, data: string) => {
    this.dashboard.L2CardValueInventory = e;
    this.dashboard.L1CardValue = 'Inventory';
    this.dashboard.valueForL3Inventory = data;
    this.clear_SortSearch_Input();
  };
  // this one is for orders
  openL2ForOrders = (e: string) => {
    this.dashboard.L2CardValueOrders = e;
    this.dashboard.valueForL3Inventory = '';
    this.dashboard.valueForL3Planning = '';
    this.dashboard.valueForL3Orders = '';
    this.dashboard.L2CardValueInventory = '';
    this.dashboard.L2CardValuePlanning = '';
    this.clear_SortSearch_Input();
    if (e === 'Inward') {
      this.dashboard.valueForL3Orders = 'Inward Request';
    }else if (e ==='Shipping') {
      this.dashboard.valueForL3Orders = 'Customer Request';
    }else if (e ==='Receiving') {
      this.dashboard.valueForL3Orders = 'Receiving';
    } else if (e ==='Outward') {
      this.dashboard.valueForL3Orders = 'Unvault';
    } else if (e ==='Reports') {
      this.dashboard.valueForL3Orders = 'Received';
    }
  };

  DenialModalOpen = (e: boolean, f: string, g: boolean, h: string) => {
    this.dashboard.DenialModal = e;
    this.dashboard.ApproveDenialHeader = f;
    this.dashboard.denyProcess = g;
    // this.dashboard.ActivityForModal=g;
    store.activityStore.loadActivityForInwards(h);
  };
  DenialModalOpen2 = (e: boolean, f: string, g: boolean, data: any) => {
    this.dashboard.DenialModal = e;
    this.dashboard.ApproveDenialHeader = f;
    this.dashboard.denyProcess = g;
    // this.dashboard.ActivityForModal=g;
    // store.activityStore.loadActivityForInwards(h);
    store.activityStore.selectedActivity = data;
  };
  reportsConfigurationOpen = (e: boolean) => {
    this.dashboard.reportsConfiguration = e;
  };

  openL3ForInventory = (e: string) => {
    this.dashboard.valueForL3Inventory = e;
    if (e === 'Verify') {
      this.dashboard.checkClikedWorkLevel = {
        id: '',
        title: '',
        barcode_Package: '',
        senderDetails:''
      };
      this.dashboard.isFilmFestival = false;
      // checkClikedWorkLevelTitle
    } else if (e === 'Tag') {
      this.dashboard.assetTableClickedValueTag = '';
      this.dashboard.checkClikedWorkLevel = {
        ...this.dashboard.checkClikedWorkLevel,
        title: '',
      };
      this.dashboard.isFilmFestival = false;
    }
    if (e === 'Create Order Receiving') {
      this.dashboard.assetTableCRClicked = '';
      this.dashboard.checkClikedWorkLevel = {
        ...this.dashboard.checkClikedWorkLevel,
        title: '',
      };
      this.dashboard.isFilmFestival = false;
    }
    if (e === 'Assign Picker Delivery') {
      this.dashboard.AssetTableAssignClicked = '';
    }
    if (e === 'Create Order') {
      this.dashboard.AssetTableCreateOrderClicked = '';
    }
    if (e === 'Delivery') {
      this.dashboard.AssetTableDeliveryClicked = '';
    }
    //setting the data to empty
    this.setcamImageBase64([]);
    this.setRegisterUrlResponse([]);
    store.receivingdeliveryStore.selectedReceivingDelivery = undefined;
    this.showClickedValueForAssetTable('');

    this.clear_SortSearch_Input();
  };
  openL3ForOrders = (e: string) => {
    this.dashboard.valueForL3Orders = e;
    this.clear_SortSearch_Input();
  };
  openL4ForOrders = (e: string) => {
    this.dashboard.valueForL4Orders = e;
  };
  setTagPageNumFunc = (e: number) => {
    this.dashboard.setTagTablePageNumber = e;
  };
  setCRTablePageNumFunc = (e: number) => {
    this.dashboard.setCRTablePageNumber = e;
  };
  setRegisterPageNum = (e: number) => {
    this.dashboard.setRegisterPageNumber = e;
  };
  setReportsPageNum = (e: number) => {
    this.dashboard.setReportsPageNum = e;
  };
  openL3ForPlanning = (e: string) => {
    this.dashboard.valueForL3Planning = e;
    this.clear_SortSearch_Input();
  };

  showClickedValueForReceiving = (e: string, f: string, g: string, sender?:string) => {
    store.receivingdeliveryStore.loadReceivingDelivery(e);
    this.dashboard.checkClikedWorkLevel = {
      id: e,
      title: f,
      barcode_Package: g,
      senderDetails: sender || ''
    };
  };

 
  showClickedValueForAssetTable = (e: string) => {
    this.dashboard.AssetTableAssignClicked = e;
    this.dashboard.AssetTableCreateOrderClicked = e;
    this.dashboard.AssetTableDeliveryClicked = e;
    this.dashboard.assetTableClickedValueTag = e;
    this.dashboard.assetTableCRClicked = e;
    // store.activityStore.loadActivity(e);
    // store.activityStore.loadActivityForInwards(e);
  };
  showClickedValueOutwardInward = (e: string) => {
    this.dashboard.AssetTableAssignClicked = e;
    this.dashboard.AssetTableCreateOrderClicked = e;
    this.dashboard.AssetTableDeliveryClicked = e;
    this.dashboard.assetTableClickedValueTag = e;
    this.dashboard.assetTableCRClicked = e;
    this.dashboard.OutwardTableBillingClicked = e;
    store.activityStore.loadActivityForInwards(e);
  };
  showPaginationValueOutwardInward = (page: number) => {
    this.dashboard.billingPagination = page;
  };
  showClickedValueOutwardAlone = (e: string, data: any) => {
    this.dashboard.AssetTableAssignClicked = e;
    this.dashboard.AssetTableCreateOrderClicked = e;
    this.dashboard.AssetTableDeliveryClicked = e;
    this.dashboard.assetTableClickedValueTag = e;
    this.dashboard.assetTableCRClicked = e;
    store.activityStore.selectedActivity = data;
  };

  // for Dashboard verify Page

  setWorkLevelMaster = (e: WorkLevel) => {
    this.dashboard.dashboardWorkLevelMaster.id = e.id;
    this.dashboard.dashboardWorkLevelMaster.title = e.title;
    this.dashboard.dashboardWorkLevelMaster.year = e.year;
    this.dashboard.dashboardWorkLevelMaster.language = e.language;
    this.dashboard.dashboardWorkLevelMaster.originIndia = e.originIndia;
  };
  setOpenCameraModal = (e: boolean) => {
    this.dashboard.openCameraModal = e;
  };
  // open WorklevelMasterModal
  setOpenWorkLevelMasterModal = (e: boolean) => {
    this.dashboard.openWorkLevelMasterModal = e;
  };
  // cam image base 64
  setcamImageBase64 = (e: Blob[]) => {
    this.dashboard.camImageBase64 = e;
  };
  // set  url response string
  setRegisterUrlResponse = (e: CameraDataRegister[]) => {
    this.dashboard.camImageUrl = e;
  };
  // set verify URL Response
  setVerifyUrlResponse = (e: FileUploadInterface[]) => {
    this.dashboard.verifyImageUrl = e;
  };

  // open modal for qrcode scanner
  setOpenQrCodeScanner = (e: boolean) => {
    this.dashboard.openQrCodeScanner = e;
  };
  // set value for qrcode scanner
  setQrCodeValue = (e: string) => {
    this.dashboard.getQrCodeValue = e;
  };
  // open modal for qrcode scanner
  setOpenBarCodeScanner = (e: boolean) => {
    this.dashboard.openBarCodeScanner = e;
  };
  // set value for qrcode scanner
  setBarCodeValue = (e: string) => {
    this.dashboard.getBarCodeValue = e;
  };
  // open modal for Rfid  scanner
  setOpenRfidScanner = (e: boolean) => {
    this.dashboard.openRfidScanner = e;
  };
  // set value for qrcode scanner
  setRfidValue = (e: string) => {
    this.dashboard.getRfidValue = e;
  };

  /////////create Order Call back use effect
  setCreateOrderClicked = (e: boolean) => {
    this.dashboard.createOrderSaveClicked = e;
  };

  setOrderRequestDetails = (delivery: DeliveryRequest) => {
    store.activityStore.loadActivityForDelivery(delivery.itemId);
    this.dashboard.orderRequestDetailsIds = delivery.itemId;
  };
  setTableClicked = (e: any, tn: string) => {
    this.dashboard.tableconfigurationClicked = e;
    this.dashboard.tableName = tn;
    const name = this.dashboard.tableconfigurationClicked?.map((item: any) => {
      return item.replaceAll(/vault/gi, 'Room');
    });
    store.userStore.user?.customerName === 'LVP CMS - AM'
      ? (this.dashboard.tableconfigurationClicked = name)
      : (this.dashboard.tableconfigurationClicked = e);
  };
  setTablevalues = (e: any) => {
    this.dashboard.tabledataValue = e;
  };
  setFinalValue = (e: any) => {
    this.dashboard.finalvalue = e;
  };
  setHeaderTable = (e: any) => {
    this.dashboard.headerTable = e;
  };
  setDrag = (e: any) => {
    this.dashboard.drag = e;
  };
  //is Dispatch Called
  setDisaptchCalled = (e: boolean) => {
    this.dashboard.isDipatchCalled = e;
  };

  showDashboardReport = () => {
    this.dashboard.openDash = true;
  };

  hideDashboardReport = () => {
    this.dashboard.openDash = false;
  };

  updateCountOrderMenu = async (userId: string, Customer?:boolean) => {
    try {
      this.dashboard.loadingCount = true;
      // if(Customer) await agent.updateCountOrder.NFAIRestroationupdateCount(userId); 
      const { data } = await await agent.NFAI.GetFilteredItemDetailscount(initialPostFilteredItemDetails);
      const countData: any = await agent.updateCountOrder.updateCount(userId);
      runInAction(() => {
        if(Customer){
          this.getMenuCount = {
            ...this.getMenuCount,
            inventoryCount: data,
            productionCount: data,
            totalTaskCount: data,
                   }
        }else{
          this.getMenuCount = countData;
        }
        this.setInventoryCountData(Customer ? this.getMenuCount : countData);
        this.dashboard.loadingCount = false;
      });
    } catch (error) {
      toast.error('Failed Update Count');
      this.dashboard.loadingCount = false;
    }
  };
  updateCreateOrderTemplate = (e: Template | undefined) => {
    //selected Template for CR
    this.dashboard.CreateOrderTemplate = e;
  };

  //dynamic table component row data id
  updateRowData = (e: any) => {
    this.dashboard.rowIdForDynamicTable = e;
  };
  setloadingData = (e: string) => {
    this.dashboard.loadingdata = e;
  };
  InventoryCountData = async () => {
    // const responseHandler = await agent.Activities.loadInventoryInfoGraphics();
    // const response2Handler = await agent.Activities.loadOrderInfoGraphics();
    // const response3Handler = await agent.Activities.loadProductionInfoGraphics();
    const isCustomer = store.userStore.user?.customerName==="NFAIReport";
    const [response, response2, response3, response4, response5, response6] =
      await Promise.all([
        agent.Activities.loadInventoryInfoGraphics(),
        agent.Activities.loadOrderInfoGraphics(),
        agent.Activities.loadProductionInfoGraphics(),
        agent.Activities.chart2(),
        agent.Activities.chart3(),
        isCustomer ? agent.NFAI.NFAILevel2() : agent.ProdPlanning.listProductionType(),
      ]);
    // const response4 = await agent.Reports.loadFFCount();
    // const response5 = await agent.Reports.loadNotFFCount();
    this.dashboard.inventoryChartData = response;
    this.dashboard.orderChartData = response2;

    // if(this.dashboard.L1CardValue ==='Inventory')   {
    let result = await agent.Activities.loadInventoryDoughnutGraphics();
    this.dashboard.inventoryDoughnutChartDetails = result || [];
    // }

    if (
      response3 !== 'Production Infographic count is null' &&
      response3.length > 0
    ) {
      let strArray: string[] = [];
      response4?.data[0]?.forEach((x: any) => {
        strArray.push(x.task);
      });
      this.dashboard.prodChartLabel = strArray;
      // ======== chart 2 count data ==========
      let localArr2: any = [];
      this.dashboard.prodChartLabel.forEach((label: any) => {
        let localArr: any = [];
        response4?.data.forEach((data1: any) => {
          for (let index = 0; index < data1.length; index++) {
            if (label === data1[index].task) {
              localArr.push(data1[index].count);
            }
          }
        });
        localArr2.push(localArr);
      });
      this.dashboard.prodChartData[2].Chart2 = localArr2;
      /// ============ chart 3 label ==========
      response5?.data?.[0]?.forEach((count1: any) => {
        this.dashboard.ProdchartInprogressLabel.push(count1.task);
      });

      // ============= chart 3 data =============
      // response5?.data?.[0]?.forEach((count1: any) => {
      //   this.dashboard.ProdchartInprogress.push(count1.count);
      // });

      response6?.data?.forEach((count1: any) => {
        this.dashboard.ProdChartComplete.push(count1.count);
      });

      // this.dashboard.prodChartData[3].Chart3InProgress = JSON.stringify(
      //   this.dashboard.ProdchartInprogress,
      // );
      this.dashboard.prodChartData[4].Chart3Complete =
        this.dashboard.ProdChartComplete;
    }
  };
  receivingCount = async () => {
    try {
      const response = await agent.ReceivingsDeliveries.receivingCount();
      this.dashboard.receivingsCount = response;
    } catch (err) {
      this.dashboard.receivingsCount = 0;
    }
  };
  tagCount = async () => {
    try {
      const response = await agent.Tag.tagCount();
      this.dashboard.tagCount = response;
    } catch (err) {
      this.dashboard.tagCount = 0;
    }
  };
  createOrderCount = async () => {
    try {
      const response = await agent.CreateOrder.tagCount();
      this.dashboard.CreateOrderCount = response;
    } catch (err) {
      this.dashboard.CreateOrderCount = 0;
    }
  };
  setInventoryCountData = (countData: any) => {
    this.dashboard.inventoryCount = countData.inventoryCount;
    this.dashboard.inventoryCount2 = store.commonStore.hfcCustomerChanges? store.dashboardStore.dashboard.inventoryCount2 : countData.inventoryCount;
    this.dashboard.itemgroupsCount = countData.itemgroups;
    this.dashboard.messageCount = countData.message;
    // this.dashboard.receivingsCount=countData.receivings;
    this.dashboard.prodCount = countData.productionCount;
    this.dashboard.prodPlanTableLength = countData.productionCount;
    this.dashboard.taskCount = countData.completedTaskCount;
    this.dashboard.taskTotal = countData.totalTaskCount;
    this.dashboard.totalOrderCount = countData.totalOrderCount;
    this.dashboard.completedOrderCount = countData.completedOrderCount;
  };
  setFilterData = (e: any) => {
    this.dashboard.searchfilterparams = e;
  };
  setFocusState = (e: string) => {
    this.dashboard.focusState = e;
  };
  setProdDataPageNum = (e: number) => {
    this.dashboard.setProdPageNumber = e;
  };
  setOrderData = (e: string) => {
    this.dashboard.orderData = e;
  };
  setOrderIcon = (e: string, f: string) => {
    this.dashboard.orderName = e;
    this.dashboard.orderIcon = f;
  };
  setIsFilmFestival = (e: boolean) => {
    this.dashboard.isFilmFestival = e;
  };
  resetDashboard = () => {
    this.dashboard = initialState;
  };
  createorderTemplatedata = (data: any) => {
    if (data !== undefined) {
      this.dashboard.CreateOrderTemplate1 = data;
    }
  };

  getLocalFilesBasedOnItem = async (itemId: string) => {
    try {
      const response = await agent.Files.getLocalFiles(itemId);
      runInAction(() => {
        this.dashboard.localFilesForItem = response?.data;
      });
    } catch {
      toast.error('Unable to fetch files');
    }
  };
}
